import * as Types from "../../actions/constants";

const initialState = {

  documentData: {
    loading: false,
    error: false,
    success:false,
    rows: { data: [], meta: [] },
  },
  updateData: {
    loading: false,
    error: false,
    success: false,
    data: null,
  },
  createData: {
    loading: false,
    error: false,
    success: false,
    data: null,
  },
  indexData: {
    loading: false,
    error: false,
    success: false,
    data: null,
  },


  

};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.CREATE_VEHICLE_DOCUMENT:
      return {
        ...state,
        createData: {
          loading: true,
          error: false,
          success: false,
          rows: { data: [], meta: [] },
        },
      };
    case Types.CREATE_VEHICLE_DOCUMENT_SUCCESS:
      return {
        ...state,
        createData: {
          loading: false,
          error: false,
          success: true,
          rows: action.response.data,
        },
      };
    case Types.CREATE_VEHICLE_DOCUMENT_ERROR:
      return {
        ...state,
        createData: {
          loading: false,
          error: true,
          success: false,
          rows: action.response,
        },
      };
    case Types.RESET_CREATE_VEHICLE_DOCUMENT:
      return {
        ...state,
        createData: {
          loading: false,
          error: false,
          success: false,
          rows: { data: [], meta: [] },
        },
      };


      case Types.UPDATE_VEHICLE_DOCUMENT:
        return {
          ...state,
          updateData: {
            loading: true,
            error: false,
            success: false,
            rows: { data: [], meta: [] },
          },
        };
      case Types.UPDATE_VEHICLE_DOCUMENT_SUCCESS:
        return {
          ...state,
          updateData: {
            loading: false,
            error: false,
            success: true,
            rows: action.response.data,
          },
        };
      case Types.UPDATE_VEHICLE_DOCUMENT_ERROR:
        return {
          ...state,
          updateData: {
            loading: false,
            error: true,
            success: false,
            rows: action.response,
          },
        };
      case Types.RESET_UPDATE_VEHICLE_DOCUMENT:
        return {
          ...state,
          updateData: {
            loading: false,
            error: false,
            success: false,
            rows: { data: [], meta: [] },
          },
        };
  





      case Types.GET_VEHICLE_DOCUMENT:
      return {
        ...state,
        documentData: {
          loading: true,
          error: false,
          success: false,
          rows: { data: [], meta: [] },
        },
      };
    case Types.VEHICLE_DOCUMENT_SUCCESS:
      return {
        ...state,
        documentData: {
          loading: false,
          error: false,
          success: true,
          rows: action.response.data,
        },
      };
    case Types.VEHICLE_DOCUMENT_ERROR:
      return {
        ...state,
        documentData: {
          loading: false,
          error: true,
          success: false,
          rows: action.response,
        },
      };

      case Types.GET_VEHICLE_DOCUMENT_BY_ID:
        return {
          ...state,
          indexData: {
            loading: true,
            error: false,
            success: false,
            rows: { data: [], meta: [] },
          },
        };
      case Types.VEHICLE_DOCUMENT_BY_ID_SUCCESS:
        return {
          ...state,
          indexData: {
            loading: false,
            error: false,
            success: true,
            rows: action.response.data,
          },
        };
      case Types.VEHICLE_DOCUMENT_BY_ID_ERROR:
        return {
          ...state,
          indexData: {
            loading: false,
            error: true,
            success: false,
            rows: action.response,
          },
        };

















    default:
      return state;
  }
};
